import Banner from '../components/Banner';
import Footer from '../components/Footer';
import Contacto from '../components/Contacto';
import React from 'react';


const ContactoPage: React.FC = () => {
  return (
    <div className="page-container">
      <Banner />
      <main className="login-main">
           <Contacto />
      </main>
      <Footer />
    </div>
  );
};

export default ContactoPage;